import PropertySmallCard from "@/Pages/Game/PropertySmallCard"
import PlayerInfoSmall from "./PlayerInfoSmall"
import {
  getCellByOrderAndMapId,
  getCellGroup,
  getMapById,
  getPlayerByPlayerOrder,
  getUserByPlayerOrder,
} from "@/utils/gameHelpers"
import classNames from "classnames"
import { useAppSelector } from "@/store/hooks"

interface TradePanelSmallProps {
  playerOrder: number
  // Net cash for this player: positive when they end up richer.
  money: number
  // The properties this player ends up *with* — the ones coming to them from the
  // other side. Named for the direction on purpose: the money below is already a
  // signed net for this player, so listing the properties they hand away in the
  // same column made the two halves point opposite ways and left "who got which
  // property" unreadable.
  receivedProperties: number[]
}
export const TradePanelSmall: React.FC<TradePanelSmallProps> = ({
  playerOrder,
  receivedProperties,
  money,
}) => {
  const myGame = useAppSelector((state) => state.global.myGame)
  const myMap = getMapById(myGame!.settings.mapId)

  const user = getUserByPlayerOrder(
    myGame as IGameDetails,
    playerOrder
  ) as IUser
  const player = getPlayerByPlayerOrder(
    myGame as IGameDetails,
    playerOrder
  ) as IPlayer
  return (
    <div className="flex items-center flex-col gap-1.5 w-full justify-between h-full">
      <PlayerInfoSmall user={user} player={player}></PlayerInfoSmall>
      <div className="flex flex-col h-full justify-between gap-2">
        {/* The cards are the same tiny art used everywhere else on the board, so
            the only thing telling a player what they mean is which column they
            sit in — spell that out rather than leaving it to be inferred. */}
        <div className="flex flex-col items-center gap-1 w-full">
          <div className="text-[10px] font-poppins font-medium uppercase tracking-[0.15em] text-white/50">
            Gets
          </div>
          {receivedProperties.length ? (
            <div className="flex flex-wrap gap-1 w-full items-center justify-center">
              {receivedProperties.map((propertyOrder) => {
                const cell = getCellByOrderAndMapId(
                  propertyOrder,
                  myGame!.settings.mapId
                ) as ICell
                const group = getCellGroup(myGame!.settings.mapId, cell)
                return (
                  <PropertySmallCard
                    key={propertyOrder}
                    height={30}
                    width={21}
                    noAnimations
                    property={cell}
                    group={group as IPropertyGroup}
                  ></PropertySmallCard>
                )
              })}
            </div>
          ) : (
            <div className="text-xs font-poppins italic text-white/40">
              No properties
            </div>
          )}
        </div>
        <div
          className={classNames("text-lg font-bold font-third", {
            "trade-panel-text-loss": money < 0,
            "trade-panel-text-success": money >= 0,

            // "text-white": money === 0,
          })}
        >
          {money >= 0 ? "+" : "-"} <span className="font-fira-sans">M</span>{" "}
          {Math.abs(money || 0)}
        </div>
      </div>
    </div>
  )
}
